import React, { useEffect, useRef, useState } from "react";
// css comes in groupWiseQuery.css
import axios from "../../../../axios";
import CreateNewQuery from "../Create Query/CreateNewQuery";
import Form from "react-bootstrap/Form";
import FilterBox from "./Filter_Box/FilterBox";
import { IP } from "../../../../internalServer";
import { Popup } from "semantic-ui-react";
import GroupMemberList from "./GroupMemberList";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ImagePopupBox from "../../../../DCM/components/PopUp/ImagePopup/ImagePopupBox";
import QureryImage from "../../../../images/Query_Process_Flow.png";
import { useLocation } from "react-router-dom";
import assets from "../../../../assets/assets";
import { PlusCircle } from "lucide-react";
// ✅ Correct

const QueryHeader = ({
  socket,
  editQueryData,
  setEditQueryData,
  setFilter,
  filter,
  change,
  setQuery,
  query,
  groupData,
  click,
  setClick,
  initialQuery,
  setIsGettingData,
  setIsPreventApiCall,
  getAllQuery,
  handleRefresh,
}) => {
  const [click1, setClick1] = useState(false);
  const [option, setOption] = useState("");
  const [openImg, setOpenImg] = useState(false);
  const { state } = useLocation();
  const [activeHeader, setActiveHeader] = useState("all");
  const [checked, setChecked] = useState({
    sortChecked: 2,
    timeChecked: 1,
  });
  const { date, tag, name, status, limit, page, sortBy, time } = filter;
  const handleClick = () => {
    setClick(true);
    change(true);
  };

  const pendingApproved = localStorage.getItem("pendingApproved");

  useEffect(() => {
    if (pendingApproved === "true") {
      setActiveHeader("approved");
    }

    setTimeout(() => {
      localStorage.setItem("pendingApproved", false);
    }, 3000);
  }, [pendingApproved]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setQuery([]);
      setFilter({
        ...filter,
        searchClick: !filter.searchClick,
      });
    }
  };
  function formatDate(inputDate) {
    console.log(inputDate);
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  const ActiveHeaderFunction = (name) => {
    setActiveHeader(name);
  };

  useEffect(() => {
    setIsGettingData(true);
    setQuery([]);
    setFilter((prev) => ({
      ...prev,
      page: 1,
      status: activeHeader,
    }));
  }, [activeHeader]);

  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  useEffect(() => {
    if (showModal && modalRef.current) {
      const modal = new window.bootstrap.Modal(modalRef.current);
      modal.show();

      // Handle modal hide
      modalRef.current.addEventListener("hidden.bs.modal", () => {
        setShowModal(false);
      });
    }
  }, [showModal]);

  return (
    <>
      <div className="px-3 mt-3 d-flex align-items-center justify-content-between query_channel_header">
        <div className="gap-2 p-2 d-flex align-items-center">
          <img
            src={
              groupData?.profile_picture
                ? IP + groupData?.profile_picture.replace(/^\./, "")
                : "/group-img/groupImg1.svg"
            }
            className="query_profileimg"
            alt=""
            onError={(e) => {
              e.target.src = assets.QueryImg;
            }}
          />
          <span className="query_channelName poppins-semibold">
            {groupData?.name}
          </span>
          <div className="query_status_img">
            <img
              src="/images/memberListIcon.png"
              className="cicle_statusImage2"
              alt=""
              style={{
                width: "37px",
                height: "35px",
                borderRadius: "50%",
                border: "1px solid gray",
              }}
            />
            <Popup
              on="click"
              trigger={
                <div className="nth_person" style={{ cursor: "pointer" }}>
                  {groupData?.member?.length}
                </div>
              }
              content={
                <GroupMemberList totalMember={groupData?.member?.length} />
              }
              position=" right "
            />
          </div>
        </div>

        <div className="d-flex align-items-center gap-3">
          <div
            onClick={(e) => setOpenImg(true)}
            style={{
              color: "red",
              fontSize: "0.8rem",
              cursor: "pointer",
            }}
          >
            *Click to Know Details
          </div>
          {!click &&
            !Object.keys(editQueryData).length > 0 &&
            initialQuery.length > 0 && (
              <>
                <button
                  className="btn btn-light creaeQueryBtn"
                  onClick={() => setClick(true)}
                >
                  <PlusCircle size={16} className="me-2" />
                  Create Query
                </button>
              </>
            )}
        </div>
      </div>
      <div className="mt-3 p-0 w-100 ">
        <div className="d-flex align-items-center justify-content-between w-100 gap-5">
          {!Object.keys(editQueryData).length > 0 &&
            initialQuery.length > 0 && (
              <>
                <div className="col-md-5 d-flex align-items-center justify-content-between main_button_box1">
                  <button
                    className={` poppins-semibold  ${
                      activeHeader === "all"
                        ? "active main_three_button_active orange-text poppins-semibold "
                        : "main_three_button "
                    }`}
                    onClick={() => ActiveHeaderFunction("all")}
                  >
                    All
                  </button>

                  <button
                    className={`  poppins-semibold  ${
                      activeHeader === "approved"
                        ? "active main_three_button_active orange-text poppins-semibold "
                        : "main_three_button "
                    }`}
                    onClick={() => ActiveHeaderFunction("approved")}
                  >
                    Active
                  </button>

                  <button
                    className={`  poppins-semibold  ${
                      activeHeader === "pending"
                        ? "active main_three_button_active orange-text poppins-semibold "
                        : "main_three_button "
                    }`}
                    onClick={() => ActiveHeaderFunction("pending")}
                  >
                    Pending
                  </button>

                  <button
                    className={`  poppins-semibold  ${
                      activeHeader === "resolved"
                        ? "active main_three_button_active orange-text poppins-semibold "
                        : "main_three_button "
                    }`}
                    onClick={() => ActiveHeaderFunction("resolved")}
                  >
                    Resolved
                  </button>
                </div>

                <div className=" header_right_box d-flex align-items-center justify-content-between w-100">
                  {/* <div className="gap-2 d-flex align-items-center status_box">
                      <span className="ststus_filter">Status:</span>
                      <Form.Select
                        className="status_dropdown"
                        style={{ height: "45px", width: "100px" }}
                        value={filter?.status}
                        onChange={(e) => {
                          setFilter({
                            ...filter,
                            page: 1,
                            status: e.target.value,
                          });
                          setQuery([]);
                        }}
                      >
                        <option value="all">All</option>
                        <option value="pending">Pending</option>
                        <option value="approved">Active</option>
                        <option value="resolved">Resolved</option>
                      </Form.Select>
                    </div> */}
                  <div className="search_container d-flex align-items-center ">
                    <div className="dropdown">
                      <Form.Select
                        style={{ border: "none" }}
                        className="search_dropdown"
                        size="sm"
                        value={option}
                        onChange={(e) => {
                          setOption(e.target.value);
                          setFilter({
                            ...filter,
                            name: "",
                            tag: "",
                            date: null,
                            page: 1,
                          });
                        }}
                      >
                        <option value="">Search by Type</option>
                        <option value="Tag">Tag</option>
                        <option value="Name">Creator</option>
                        <option value="Date">Date</option>
                      </Form.Select>
                    </div>
                    <div className="search_input_cont">
                      {option === "Date" ? (
                        <DatePicker
                          selected={date}
                          placeholderText="mm/dd/yyyy"
                          onChange={(date) =>
                            setFilter({
                              ...filter,
                              name: null,
                              tag: null,
                              page: 1,
                              date: date,
                            })
                          }
                          className="search_calendar_Box"
                          onKeyDown={(e) => handleKeyDown(e)}
                        />
                      ) : option === "Name" ? (
                        <input
                          type="text"
                          value={name}
                          className="search_boxs"
                          placeholder="enter name"
                          maxLength={150}
                          onKeyDown={(e) => handleKeyDown(e)}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              date: null,
                              tag: null,
                              page: 1,
                              name: e.target.value,
                            })
                          }
                        />
                      ) : option === "Tag" ? (
                        <input
                          type="text"
                          value={tag}
                          className="search_boxs"
                          placeholder="enter tag"
                          onKeyDown={(e) => handleKeyDown(e)}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              date: null,
                              name: null,
                              page: 1,
                              tag: e.target.value,
                            })
                          }
                        />
                      ) : (
                        <div style={{ width: "100px" }}></div>
                      )}
                    </div>
                    <img
                      src="/images/search icon black.svg"
                      className="query_search_icon mt-1"
                      alt="Search"
                      style={{
                        opacity:
                          filter.name || filter.tag || filter.date ? 1 : 0.5,
                        cursor:
                          filter.name || filter.tag || filter.date
                            ? "pointer"
                            : "not-allowed",
                      }}
                      onClick={(e) => {
                        // Only trigger search if one of the fields has a value
                        if (filter.name || filter.tag || filter.date) {
                          setQuery([]);
                          setFilter({
                            ...filter,
                            searchClick: !filter.searchClick,
                          });
                        }
                      }}
                    />
                  </div>
                  <div className="mr-1 ml-1">
                    <img
                      src="/images/black_filter_icon.svg"
                      alt=""
                      onClick={(e) => setClick1(true)}
                    />
                  </div>
                  <div className="query_status_img">
                    {click1 && (
                      <FilterBox
                        setChecked={setChecked}
                        checked={checked}
                        setFilter={setFilter}
                        filter={filter}
                        setClick1={setClick1}
                        setQuery={setQuery}
                      />
                    )}
                  </div>
                  <p
                    style={{
                      margin: "4px 5px",
                      color: "#f88409",
                      fontWeight: "500",
                      fontSize: "14px",
                      textDecoration: "underline",
                      width: "16%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleRefresh();
                      // setActiveHeader("all");
                      // setOption("tag");
                    }}
                  >
                    Clear Search
                  </p>
                  <button
                    style={{
                      border: "none",
                      color: "white",
                      backgroundColor: "#74be65",
                      borderRadius: "5px",
                      padding: "5px 13px",
                      fontSize: "12px",
                      fontWeight: "600",
                      marginRight: "15px",
                    }}
                    onClick={() => {
                      handleRefresh();
                      setActiveHeader("all");
                      setOption("tag");
                    }}
                  >
                    Refresh
                  </button>
                </div>
              </>
            )}
        </div>
      </div>
      {/* {(Object.keys(editQueryData).length > 0 || click) && (
        <CreateNewQuery
          editQueryData={editQueryData}
          setEditQueryData={setEditQueryData}
          socket={socket}
          change={setClick}
          headerChange={change}
          groupData={groupData}
        />
      )} */}
      {(Object.keys(editQueryData).length > 0 || click) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="bg-white rounded-3 shadow-lg d-flex flex-column"
            style={{
              width: "90vw",
              maxWidth: "900px",
              maxHeight: "80vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Body */}
            <div className=" overflow-auto" style={{ flexGrow: 1 }}>
              <CreateNewQuery
                editQueryData={editQueryData}
                setEditQueryData={setEditQueryData}
                setActiveHeader={setActiveHeader}
                socket={socket}
                change={setClick}
                headerChange={change}
                groupData={groupData}
                handleRefresh={handleRefresh}
              />
            </div>
          </div>
        </div>
      )}
      {openImg && (
        <ImagePopupBox setOpenImg={setOpenImg} imgSrc={QureryImage} />
      )}
    </>
  );
};

export default QueryHeader;
